// sideMenuTheme.js
// The sidebar skin. The app serves 1TVET only (2026-10-30), so there is a single skin and it is the
// legacy one:
//
//   #E2EBFF   SideMenuNew.js:531 (sider, expanded), :542 (sider, collapsed), :554 (header),
//             :648 (Menu) — corroborated by 1TVET App.less:144, :157, :236, :241, :306.
//   #033D89   the campus's accent: the fold/unfold trigger in the sidebar header. The legacy sheet
//             painted that trigger with the primary colour of its own antd build.
//   280px     SideMenuNew.js:544 `width={'280px'}`.
//   220x50    SideMenuNew.js:615/:617 header logo.
//   45x45     SideMenuNew.js:569/:579/:594 header avatar — also what the collapsed rail showed.
//   centred   SideMenuNew.js:555-557 `justifyContent: 'center'` with avatar *then* logo.
//
// Hover and selected states are not here: they are `:hover` / `.ant-menu-item-selected` states of
// an antd <Menu>, so they live in sideMenu.css, next to the component that renders it — a navy pill
// for the selected row, a light navy wash behind the hovered one.

export const SIDEBAR_THEME = Object.freeze({
   background: '#E2EBFF',
   // The fold/unfold trigger.
   accent: '#033D89',
   width: 280,
   logo: Object.freeze({ width: 220, height: 50 }),
   collapsedLogo: Object.freeze({ width: 41, height: 40 }),
   avatarSize: 45,
   // The legacy rail showed the user's picture, not the logo (SideMenuNew.js:559-586).
   collapsedShowsAvatar: true,
   // Header reads avatar, then logo (SideMenuNew.js:588-620).
   avatarFirst: true,
   headerJustify: 'center',
   // The legacy header let Admins change the school year too (SideMenuNew.js:613).
   schoolYearRoles: Object.freeze(['Super Admin', 'Admin']),
});

/**
 * The sidebar skin. It reads no tenant any more — every deployment is a 1TVET campus — but the
 * call sites keep the resolver shape they were written against.
 */
export const getSidebarTheme = () => SIDEBAR_THEME;

